<template>
	<div class="hstack gap-2 align-items-center">
		<CommonImageSquarePlaceholder size="md" rounded="3" :border="true" class="mx-auto" v-if="placeholder" />
		<CommonImageSquare :src="company?.avatar_url" size="md" rounded="3" :border="true" class="mx-auto" v-else />
		<div class="flex-fill lh-sm text-limit text-start" :class="{ 'placeholder-glow': placeholder }">
			<div class="link-primary text-md text-truncate fw-bold placeholder col-12" v-if="placeholder"></div>
			<router-link :to="{ name: 'company.admin.home', params: { company_id: company?.id }}" class="link-primary text-md text-truncate fw-bold stretched-link" v-else-if="redirect">{{ company?.name }}</router-link>
			<div class="text-primary text-md text-truncate fw-bold" v-else>{{ company?.name }}</div>
			<div class="text-sm text-truncate text-muted" :class="{ 'placeholder col-8': placeholder }" v-if="subtitle || !company?.id">{{ subtitle }}</div>
			<div class="text-sm text-truncate text-muted hstack gap-1" v-if="balance"><b>Balance:</b> {{ vueNumberFormat(balance.amount, { suffix: ` ${balance.currency}`, precision: 2 }) }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			company: Object,
			balance: Object,
			subtitle: {
				type: String,
				default: null
			},
			placeholder: {
				type: Boolean,
				default: false
			},
			redirect: {
				type: Boolean,
				default: false
			}
		}
	}
</script>